import React, { useEffect } from 'react';
import { useFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { FieldInput, FieldRadio } from '../../fields';
import { Error } from '../../../design/elements';
const PaymentPlanTerm = ({ discountApprovalRef, defaultValues }) => {
  const validationSchema = Yup.object().shape({
    paymentPlanTerm: Yup.string().required('Field is required'),
    appendicesIncluded: Yup.string().required('Field is required')
  });
  const formik = useFormik({
    initialValues: defaultValues,
    enableReinitialize: true,
    onSubmit: async (values, actions) => {
      try {
        await validationSchema.validate(values, { abortEarly: false });
        if (values.discountValue) {
          values.discountValue = Number(values.discountValue).toFixed(2);
          values.discountValue = values.discountValue.toString();
        }
      } catch (validationErrors) {
        const errors = {};
        validationErrors.inner.forEach(error => {
          errors[error.path] = error.message;
        });
        actions.setErrors(errors);
      } finally {
        actions.setSubmitting(false);
      }
    }
    // validationSchema
  });
  useEffect(() => {
    if (discountApprovalRef) {
      // eslint-disable-next-line no-param-reassign
      discountApprovalRef.current = formik;
    }
  }, [discountApprovalRef, formik]);
  return (
    <Formik initialValues={formik.initialValues} enableReinitialize>
      <form>
        <div style={{ marginBottom: '170px' }}>
          <FieldRadio
            data={{
              name: 'paymentPlanTerm',
              type: 'text',
              label: 'Project Payment Plan Term',
              value: formik.values.paymentPlanTerm,
              required: true,
              onChange: e =>
                formik.setFieldValue('paymentPlanTerm', e.target.value),
              tooltip: '',
              note: null,
              disabled: false,
              noteAppearsBelowField: false,
              isShowNoteBackground: false,
              options: [
                { fields: { value: 'One Time', label: 'One Time' } },
                { fields: { value: '12 months', label: '12 months' } }
              ]
            }}
          />
          {formik.touched.paymentPlanTerm && formik.errors.paymentPlanTerm ? (
            <Error text={formik.errors.paymentPlanTerm} />
          ) : null}
          {formik.values.paymentPlanTerm === 'One Time' && (
            <>
              <FieldInput
                data={{
                  ref: null,
                  name: 'OneTimeCharge',
                  type: 'number',
                  label: 'One Time Charge',
                  value: formik.values.OneTimeCharge,
                  required: false,
                  onChange: e =>
                    formik.setFieldValue('OneTimeCharge', e.target.value),
                  readonly: false,
                  tooltip: '',
                  note: null,
                  disabled: true,
                  noteAppearsBelowField: false,
                  isShowNoteBackground: false
                }}
              />
              <FieldInput
                data={{
                  ref: null,
                  name: 'monthlyCharge',
                  type: 'number',
                  label: 'Monthly Charge',
                  value: formik.values.monthlyCharge,
                  required: false,
                  onChange: e =>
                    formik.setFieldValue('monthlyCharge', e.target.value),
                  readonly: false,
                  tooltip: '',
                  note: null,
                  disabled: true,
                  noteAppearsBelowField: false,
                  isShowNoteBackground: false
                }}
              />
            </>
          )}
          {formik.values.paymentPlanTerm === '12 months' && (
            <FieldInput
              data={{
                ref: null,
                name: 'monthlyChargeOneTime',
                type: 'number',
                label: 'Monthly Charge',
                value: formik.values.monthlyChargeOneTime,
                required: false,
                onChange: e =>
                  formik.setFieldValue('monthlyChargeOneTime', e.target.value),
                readonly: false,
                tooltip: '',
                note: null,
                disabled: true,
                noteAppearsBelowField: false,
                isShowNoteBackground: false
              }}
            />
          )}
          <FieldRadio
            data={{
              name: 'appendicesIncluded',
              type: 'text',
              label: 'Are there any appendices that need to be included?',
              value: formik.values.appendicesIncluded,
              required: true,
              onChange: e =>
                formik.setFieldValue('appendicesIncluded', e.target.value),
              tooltip: '',
              note: null,
              disabled: false,
              noteAppearsBelowField: false,
              isShowNoteBackground: false,
              options: [
                { fields: { value: 'Yes', label: 'Yes' } },
                { fields: { value: 'No', label: 'No' } }
              ]
            }}
          />
          {formik.touched.appendicesIncluded &&
          formik.errors.appendicesIncluded ? (
            <Error text={formik.errors.appendicesIncluded} />
          ) : null}
        </div>
      </form>
    </Formik>
  );
};
PaymentPlanTerm.propTypes = {
  discountApprovalRef: PropTypes.shape({
    current: PropTypes.shape({}).isRequired
  }).isRequired,
  defaultValues: PropTypes.shape({
    paymentPlanTerm: PropTypes.string.isRequired,
    appendicesIncluded: PropTypes.string.isRequired
  }).isRequired
};
export default PaymentPlanTerm;
